const tableCellStyle = {
  borderBottom: "1px solid #EDF2F7",
  fontFamily: "Inter",
  fontSize: "12px",
  fontStyle: "normal",
  lineHeight: "normal",
  height: "56px",
  padding: "8px 24px",
};

const tableRowStyle = {
  ":hover": {
    backgroundColor: "#EDF5FF",
  },
};

const tableHeadStyle = {
  color: "#98A2B3",
  fontWeight: "bold !important",
  background: "#FAFAFB",
  fontFamily: "Inter",
  fontSize: "12px",
  fontStyle: "normal",
  lineHeight: "100%",
  padding: "8px 24px",
  width: "190px",
  height: "48px",
  ...tableCellStyle,
};

const tableContainerStyle = {
  boxShadow: "none",
  borderRadius: "0px",
  width: "100%",
  mb: 2,
};

const tabStyle = {
  fontFamily: "Inter",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "100%",
  padding: "8px 0px",
  width: { xs: "149px", sm: "190px" },
  height: "48px",
};

const menuItemStyle = {
  fontFamily: "Inter",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  color: "#292727",
  ":hover": {
    background: "#EDF5FF",
  },
  ":active": {
    background: "#FFFFFF",
  },
};

const SelectInputStyle = {
  "& .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #DEDEDE",
  },
  "& .MuiSelect-select": {
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#425466",
  },
};

const inputStyle = {
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#98A2B3",
    borderRadius: "8px",
  },

  "& .MuiOutlinedInput-input": {
    color: "#98A2B3",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
};

const navLinkStyle = ({ isActive, isPending }) => {
  return {
    fontWeight: isActive || isPending ? "bold" : "normal",
    color: isActive || isPending ? "#1E87FF" : "#292727",
    fontFamily: "Inter",
    fontSize: "14px",
  };
};

const listItemButtonStyle = {
  pl: 4,
  mt: 2,
  pr: 0,
  ":hover": { fontWeight: 700, color: "#1E87FF" },
};

const dividerStyle = { borderColor: "#EDF2F7" };

export {
  tableRowStyle,
  tableHeadStyle,
  tableContainerStyle,
  tableCellStyle,
  tabStyle,
  menuItemStyle,
  SelectInputStyle,
  dividerStyle,
  inputStyle,
  navLinkStyle,
  listItemButtonStyle,
};
